export default {
  disciplinarySettings: undefined,
  paymentSettings: undefined
}
